import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../../../application/core/State';
import api from '../../core/api';
import { catchError, map, mergeMap, startWith } from 'rxjs/internal/operators';
import EstimationPlaceRequested from '../events/EstimationPlaceRequested';
import EstimationsPlaceSucceed from '../events/EstimationsPlaceSucceed';
import EstimationsPlaceFailed from '../events/EstimationsPlaceFailed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import { Month } from '../../../view/admin/getEstimationMonths';
import estimationsToDto from './estimationsToDto';
import EstimationsPlaceRequestSent from '../events/EstimationsPlaceRequestSent';

export interface ItemEstimationDraftDto {
    sku: string;
    value: number;
}

export interface ArticleEstimationDraftDto {
    articleId: string;
    itemsEstimations: ItemEstimationDraftDto[];
}

export interface MonthEstimationDraftDto {
    month: Month;
    articlesEstimations: ArticleEstimationDraftDto[];
}

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationPlaceRequested.type),
        mergeMap(() => {
            const dto: MonthEstimationDraftDto[] = estimationsToDto(state$.value.estimations.estimations);

            return backend.put(`${api()}estimations/place`, JSON.stringify(dto)).pipe(
                map(() => new EstimationsPlaceSucceed(state$.value.estimations.estimations)),
                catchError(() => of(new EstimationsPlaceFailed())),
                startWith(new EstimationsPlaceRequestSent())
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationsPlace.ts